import i18n from "@/i18n/i18n";

export function getAll() {
  return [
    {
      value: 0,
      name: "None",
      text: `${i18n.global.t("enums.rankType.None")}`,
    },
    {
      value: 1,
      name: "Qty",
      text: `${i18n.global.t("enums.rankType.Qty")}`,
    },
    {
      value: 2,
      name: "Total",
      text: `${i18n.global.t("enums.rankType.Total")}`,
    },
  ];
}
